import { PROFORM_INVOICE_LIST_FAIL, PROFORM_INVOICE_LIST_REQUEST, PROFORM_INVOICE_LIST_SUCCESS, PROFORM_INVOICE_LIST_UPDATE } from "../constats/proforma_invoice.constant";

export const proformaInvoiceListReducer = (state={}, action) => {
    switch (action.type) {
        case PROFORM_INVOICE_LIST_REQUEST:
            return {
                loading: true
            };
        case PROFORM_INVOICE_LIST_FAIL:
            return {
                loading: false,
                error: action.payload
            };
        case PROFORM_INVOICE_LIST_SUCCESS:
            return {
                loading: false,
                data: action.payload
            };
        case PROFORM_INVOICE_LIST_UPDATE:
            return {
                ...state,
                data: {
                    ...state.data,
                    data: state.data.data.map(element =>
                        element.id === action.payload.id ? { ...action.payload } : element
                    )
                }
            };
        default:
            return state;
    }
}